<template>
  <div id="app">
    <!-- <gheader :headerIsShow="headerIsShow"></gheader> -->
    <router-view />
  </div>
</template>
<script>
import VConsole from "vconsole";
export default {
  name: "App",
  data() {
    return {
      headerIsShow: false,
    };
  },
  mounted() {
    let vConsole = new VConsole();
  },
  methods: {},
};
</script>

<style>
#app {
  max-width: 1024px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue